"use client"

import dynamic from "next/dynamic"

interface PriceProps {
  amount: number
  className?: string
}

const ClientPrice = dynamic(
  () => import("./client-price").then((mod) => mod.ClientPrice),
  {
    ssr: false,
    loading: () => <span>—</span>
  }
)

export function Price({ amount, className = "" }: PriceProps) {
  if (amount === undefined || amount === null) {
    return <span className={className}>-</span>
  }

  return <ClientPrice amount={amount} className={className} />
}
